const ar = {
  common: {
  ok: "موافق",
  cancel: "إلغاء",
  },
  greetings: {
    hello: "مرحبًا، {{name}}!",
  },
};

export default ar;
  